import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Bau365DataAccessAuthenticationModule } from '@planone/bau365/data-access-authentication';
import { DataAccessSearchFacade } from '@planone/bau365/data-access-search';
import { SharedFeatureCookieConsentModule } from '@planone/shared/feature-cookie-consent';
import { SharedFeatureTrackingGoogleAnalyticsModule } from '@planone/shared/feature-tracking-google-analytics';
import { SharedFeatureTrackingSnowplowModule } from '@planone/shared/feature-tracking-snowplow';

import { DataTransformationHelper } from './helper/data-transformation.helpers';
import { AuthenticationEffects } from './state/authentication/authentication.effects';
import { GoogleAnalyticsEffects } from './state/enricher/google-analytics.effects';
import { SnowplowEffects } from './state/enricher/snowplow.effects';
import { ExportEffects } from './state/export/export.effects';
import { GenerateBusinessCardEffects } from './state/generate-business-card/generate-business-card.effects';
import { LinkClickEffects } from './state/link-click/link-click.effects';
import { LinkClickFacade } from './state/link-click/link-click.facade';
import { NewsfeedEffects } from './state/newsfeed/newsfeed.effects';
import { DiscoverEffects } from './state/pageview/discover.effects';
import { EventsEffects } from './state/pageview/events.effects';
import { ExhibitorsEffects } from './state/pageview/exhibitors.effects';
import { FairsEffects } from './state/pageview/fairs.effects';
import { GeneralEffects } from './state/pageview/general.effects';
import { PostsEffects } from './state/pageview/posts.effects';
import { ProductsEffects } from './state/pageview/products.effects';
import { ProfileCompletionEffects } from './state/profile-completion/profile-completion.effects';
import { ScrollEffects } from './state/scroll/scroll.effects';
import { SearchEffects } from './state/search/search.effects';
import { ShareEffects } from './state/share/share.effects';
import { ShareFacade } from './state/share/share.facade';
import { ShowAllEffects } from './state/show-all/show-all.effects';
import { SubscribeEffects } from './state/subscribe/subscribe.effects';
import { SubscribeFacade } from './state/subscribe/subscribe.facade';
import { SwiperEffects } from './state/swiper/swiper.effects';
import { TabChangeEffects } from './state/tab-change/tab-change.effects';
import { TabChangeFacade } from './state/tab-change/tab-change.facade';
import { UserEffects } from './state/user/user.effects';
import { WatchlistEffects } from './state/watchlist/watchlist.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([
      EventsEffects,
      ExhibitorsEffects,
      FairsEffects,
      GeneralEffects,
      PostsEffects,
      ProductsEffects,
      ProductsEffects,
      TabChangeEffects,
      ShareEffects,
      SwiperEffects,
      WatchlistEffects,
      LinkClickEffects,
      ScrollEffects,
      AuthenticationEffects,
      ProfileCompletionEffects,
      ShowAllEffects,
      NewsfeedEffects,
      DiscoverEffects,
      SearchEffects,
      UserEffects,
      GoogleAnalyticsEffects,
      SnowplowEffects,
      ExportEffects,
      SubscribeEffects,
      GenerateBusinessCardEffects,
    ]),
    Bau365DataAccessAuthenticationModule,
    SharedFeatureCookieConsentModule,
    SharedFeatureTrackingGoogleAnalyticsModule,
    SharedFeatureTrackingSnowplowModule,
  ],
  providers: [
    DataTransformationHelper,
    TabChangeFacade,
    ShareFacade,
    SubscribeFacade,
    LinkClickFacade,
    DataAccessSearchFacade,
  ],
})
export class Bau365FeatureTrackingModule {}
